import React, { useEffect, useState, useMemo } from 'react';
import FollowupAdminPresenter from "../../../presenters/screens/followup-admin.presenter";
import { IFollowupAdmin } from "@interfaces/screens/followup-admin.interface";
import { Container, Row, Col } from 'reactstrap';
import { Button } from 'reactstrap';
import { MasterDataGrid } from "@/components/";

interface IAdminMassiveProcessProps{
    dataColumns: any,
}

const AdminMassiveProcess: React.FC<IAdminMassiveProcessProps> = ({dataColumns} : IAdminMassiveProcessProps) => {
    const [years, setYears] = useState(null)
    const [yearSelected, setYearSelected] = useState(null)
    const [dimensionsData, setDimensionData] = useState<any>([]);

    const view: IFollowupAdmin = {
        state: {
            years,
            dimensionsData,
            yearSelected,
            dataColumns,
            setYearSelected
        },
    };
    
    const presenter = new FollowupAdminPresenter(view);

    useEffect(() => {
        if(presenter.followupData?.length && presenter.formMasters && presenter.subProjectDimensions?.length && !years){
            let {dataYears, auxDimensions} = presenter.getMassiveData(presenter.followupData, presenter.subProjectDimensions)
            setYears(dataYears)
            setDimensionData(auxDimensions)
        }
    }, [presenter.formMasters, presenter.followupData, presenter.subProjectDimensions])

    const dimData = useMemo(() => 
    presenter.getActualDimension(yearSelected, dimensionsData),
		[yearSelected, dimensionsData]
	)

    return (
        <Container fluid>
            <div style={{display: "flex", justifyContent: "right", alignContent: "center", alignItems: "flex-end"}}>
                <Button color="primary" onClick={() => presenter.saveMassiveData()}>{presenter.followupLabels.get("saveChanges")}</Button>
            </div>
            <Row xs="2" sm="2" md="2" lg="2" xl="2">
                {years && <Col>
                    <MasterDataGrid
                        id={`massive-process-years`}
                        dataSource={years}
                        keyExpr={"year"}
                        columns={presenter.getSubProjectsColumns()}
                        gridProps={presenter.getMassiveProcessGrids()}
                    /></Col>
                }
                {yearSelected && <Col>
                    <MasterDataGrid
                        id={`massive-process-dimensions`}
                        dataSource={dimData}
                        columns={presenter.getMassiveDimensionsColumns()}
                        gridProps={presenter.getMassiveDimensionsGrids()}
                    /></Col>
                }
            </Row>
        </Container>
    )
    
}

export default AdminMassiveProcess;